
import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
//import { ProductService } from './service/ProductService';
import axios from 'axios';
import { getUrl } from '../../../../ApiCall/GetUrl';
import ConfirmaCitaLawyer from './ConfirmaCitaLawyer';




export default function HorariosTable( { idlawyer }) {
    var [lawyers, setLawyers] = useState([ ]);
    const [products, setProducts] = useState([]);
    const [horarios,setHorarios] = useState([1])
    const [horariosFull,setHorariosFull] = useState([])
    const [theState,setTheState] = useState( false )
    const [myaction,setAction] = useState( 0 ) ; // 1 desbloquear
    const [theClient,setTheClient] = useState( null )


    console.log( "idlawyer =======" , idlawyer )

    function getAction()
    {
      return myaction
    }

    function confirmCalendar( comment  )
    {
      console.log( "Confirm = " , theClient )
      console.log( "Comment = " + comment ) ;
  
      var myClient = theClient ;
      //myClient.comment = comment ;

      console.log( "myClient = " , myClient )
  
      //return ;

      if ( myClient.status === 2){

        console.log( "deletecita " , myClient )


        axios.post( getUrl() + "/deletecita" , myClient )
        .then((response) => {
    
          console.log( response )
    
          setHorarios( [])
    
          getHorarios() ; // Recargamos los horarios
    
        })
        .catch((err)=>{
          console.log( err) ;
        })

        return ;

      }

      console.log( "Nos vamos a desbloquear cita")
  
      axios.post( getUrl() + "/unbloqcita" , myClient )
      .then((response) => {
  
        console.log( response )
  
        setHorarios( [])
  
        getHorarios() ; // Recargamos los horarios
  
      })
      .catch((err)=>{
        console.log( err) ;
      })
  
  
  
    }
  

useEffect(() => {
  
      console.log( "Tarjeta theState lawyers = " , theState ) ;
  
} , [theState])


function getHorarios()
{

  console.log( "getHorarios = " , getUrl() + "/horarioslawyerid?id=" + idlawyer )

  axios.get( getUrl() + "/horarioslawyerid?id=" + idlawyer ).then(response => {

    console.log( "horarioslawyer(1) = " , response.data ) ;
    //setHorarios([]);
    setHorarios( response.data )
    console.log("Este es el response data de horarios lawyer: ", response.data);

    buildHorarios() ;

  }).catch(error => {
    console.log("Error fetching data de horarios: ", error);
    setHorarios(["Hubo un error al obtener la información"]);
  })
}


  useEffect( () => {
    if ( true /*horarios.length > 0 */)
    {

      console.log( "useEffect horarios.length = " , horarios.length )

      var theHorarios = buildHorarios()

      console.log( "theHorarios.length = " + theHorarios.length )

      setHorariosFull( theHorarios ) ;
    }
    
  } ,[horarios])


  function buildHorarios()
  {
    var arr = [] ;

    console.log( "lawyers.length = " + lawyers.length ) 

    for( var i = 0 ; i < lawyers.length ; i++ ) // Recorremos uno ( el del abogado )
    {
      var obj ={

        id : lawyers[i].id ,
        horarios : fillEmpty( lawyers[i].id )

      }

      arr.push( obj ) ;

    }


    return arr ;
  }


  function fillEmpty( id  ) // dd del cliente
  {

    //console.log( "A procesar " + id )

    var arr = []

    var hrs = [

      "08:00" ,
      "08:30" ,
      "09:00" ,
      "09:30" ,
      "10:00" ,
      "10:30" ,
      "11:00" ,
      "11:30" ,
      "12:00" ,
      "12:30" ,
      "13:00" ,
      "13:30" ,
      "14:00" ,
      "14:30" ,
      "15:00" ,
      "15:30" ,
      "16:00" ,
      "16:30" ,
      "17:00" ,
      "17:30" ,
      "18:00" ,
      "18:30" ,
      "19:00" ,
      "19:30" ,
      "20:00" ,
      "20:30" ,

    ]

    function onClick2( val )
    {
      console.log( "OnClick2") ;
      setAction(  myaction + ( 1 - myaction) ) ; 


      setTheState( theState => !theState   ) ;
      

      var result = new Date();
      result.setDate(result.getDate() + parseInt( val.target.attributes["day"].value) );


      console.log( "day = " + parseInt( val.target.attributes["day"].value ) ) 

      var obj = {

        //id : val.target.attributes["idcalendar"].value ,
        idlawyer :   val.target.attributes["lawyer"].value ,
        datetime : getFormatDateShort( result ) + " " + val.target.attributes["hour"].value ,
        
        status : 1 , // Cita confirmada
        dTimeStamp : new Date()

      }

      setTheClient( obj ) ;

      // LO mandamos a desbloquear
    }

    function onClick( val )
    {
      console.log( "client = " , ( val.target.attributes["client"].value === null ? "null" : val.target.attributes["client"].value ) )  ;

      //return ; // En espera de modificaciones

      console.log( "client = " , val.target.attributes["client"].value ) // day={0} hour={'08:00'}
      console.log( "day = " , val.target.attributes["day"].value ) 
      console.log( "hour = " , val.target.attributes["hour"].value ) 

      var status = val.target.attributes["status"].value
      console.log( "status = " , status )


      if ( status === "2")
      {
        return ;
      }
      
        var result = new Date();
        result.setDate(result.getDate() + parseInt( val.target.attributes["day"].value) );
      
      var obj = {

        idcalendar : val.target.attributes["idcalendar"].value ,
        idlawyer : val.target.attributes["lawyer"].value , // Hay que traerlo
        idclient : val.target.attributes["client"].value ,
        //day : val.target.attributes["day"].value ,

        //hour : val.target.attributes["hour"].value ,

        datetime : getFormatDateShort( result ) + " " + val.target.attributes["hour"].value , 
        status : 2 // Cita confirmada
        

      }
      setTheClient( obj ) ;
      setAction( myaction + ( 2 - myaction) )
      setTheState( theState => !theState   ) ;

      

      

      //console.log( "onClick = " , theState )


      // val.target.attributes["row"]
    }


    for( var i = 0 ; i < 26 ; i++ ) // Todos los horarios
    {

      var row = [] // Este es un renglon con horarios
      
      for( var  j = 0 ; j < 14 ; j++ ) // todos los dias
      {

        //console.log( "horarios.length = " + horarios.length + " id = " + id )

        //var horariofound = "----"
        var horariofound = <button onClick={onClick2} title='Bloqueado'
        lawyer={id} day={j} hour={hrs[i]} 
        style={{borderRadius :'4px' , width : '70px' , textDecoration :  'line-through'  ,
        height :'35px' , color : "black" , borderColor : 'transparent' /*, backgroundColor : "rgb(238,244,256)" */}}>{hrs[i]} </button>

        var isFound = false ;

        for( var k = 0 ; k < horarios.length ; k++ ) // Todos los horarios
        {
          //console.log( "horarios.datetime = " + horarios[k].datetime + " cliente = " + id )

          

         var localDate = new Date( horarios[k].datetime ) // ( se la quite )Se supone que lo deja a la fecha local
          //var localDate = new Date( getFormatDate( horarios[k].datetime ) )

          console.log( "horario orig = " , horarios[k].datetime)
          console.log( "localdate = " , localDate )
          

          localDate.setHours(localDate.getHours() + 2);// ( se la quite )

          var strDate2 = getFormatDate( localDate )

          //console.log( "strDate = " + strDate ) ; // 11 , 5

          var strDate = strDate2.substring( 11 , 16 )

          //console.log( "strDate = " + strDate )

          var theDiff = dateDiffInDays( new Date() , localDate ) ;

          
          // horarios[k].datetime =  2025-04-17T12:00:00.000Z ( Desde la nube )
          // horarios[k].datetime =  2025-04-17T14:00:00.000Z ( desde local )

           if ( horarios[k].idlawyer === id && theDiff === j )
           {
              console.log( "horarios[k].datetime = " , horarios[k].datetime  )
              console.log( "localdate = " , strDate2 + " theDiff = " + theDiff  + " j = " + j );
              console.log( "k = " + k + " hrs[i] = " + hrs[i] + " strDate = " , strDate )

              if ( strDate === hrs[i])
              {

                
                console.log( "strDate = " + strDate + " hrs = " + hrs[i] + " index = " + i )
                console.log( "Si encontramos horario en el cliente******** " + id + " dia = " + theDiff )
                console.log( "localdate = " + localDate )
                console.log( "Siguiente = " + hrs[i+1])
                
                // horarios[k].idclient
                horariofound = <button onMouseOver={onOver} 
                  client={(horarios[k].idclient===null?0:horarios[k].idclient)} idcalendar={horarios[k].id}
                  lawyer={id} day={theDiff} hour={hrs[i]}  status={horarios[k].status}
                  title= { horarios[k].status === 1 ? 'Disponible' : "Reservado" }
                  onMouseOut={onOut} onClick={(val) => onClick(val)} 
                  style={{borderRadius :'4px' , width : '70px' , textDecoration :  horarios[k].status === 2 ? 'line-through' : '' ,
                    height :'35px' , color : "black" , borderColor : 'transparent' , backgroundColor : "rgb(238,244,256)"}}>{hrs[i]}</button> 

                isFound = true ;

              }

           
            }

            if ( !isFound )
            {
              //horariofound = <button onClick={onClick2} style={{textDecoration : 'line-through'}}>{hrs[i]} </button>

              //console.log( "Lo hemos encontrado en theDiff = " + j )

              horariofound = <button onClick={onClick2} title='Bloqueado'
                lawyer={id} day={j} hour={hrs[i]} 
                style={{borderRadius :'4px' , width : '70px' , textDecoration :  'line-through'  ,
                height :'35px' , color : "black" , borderColor : 'transparent' /*, backgroundColor : "rgb(238,244,256)" */}}>{hrs[i]} </button>
            }

        }

        row.push( horariofound )
      }

      arr.push( row )

      console.log( "Agregando renglon")

    }

    console.log( "El arrelo al final = " + arr.length )
    return arr ;

  }


  function onOver(event)
  {
    event.target.style.borderColor = 'black';
  }

  function onOut(event)
  {
    event.target.style.borderColor = 'transparent';
  }


  function dateDiffInDays(d1 , d2) {
    d2.setHours( 0 , 0 , 0 , 0 ) // date.setHours(0, 0, 0, 0)
    d1.setHours( 0 , 0 , 0 , 0 )

    var t2 = d2.getTime();
    var t1 = d1.getTime();

    

    return Math.floor((t2-t1)/(24*3600*1000));

}


function getFormatDate(d) {
  var date = new Date(d);
  var dateStr =
      date.getFullYear() + "-" +
      ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
      ("00" + date.getDate()).slice(-2) + " " +
    ("00" + date.getHours()).slice(-2) + ":" +
    ("00" + date.getMinutes()).slice(-2) + ":" +
    ("00" + date.getSeconds()).slice(-2);
  //console.log(dateStr);

  return dateStr;
}

function getFormatDateShort(d) {
  var date = new Date(d);
  var dateStr =
      date.getFullYear() + "-" +
      ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
      ("00" + date.getDate()).slice(-2) 

  //console.log(dateStr);

    return dateStr;
}



    const months = {
        1: "Enero",
        2: "Febrero",
        3: "Marzo",
        4: "Abril",
        5: "Mayo",
        6: "Junio",
        7: "Julio",
        8: "Agosto",
        9: "Septiembre",
        10: "Octubre",
        11: "Noviembre",
        12: "Diciembre"
      };
    


    var columns = [];
  let fecha = new Date();


  for (let i = 0; i < 14; i++) {
    var obj = { field: i.toString() /*fecha.getDate()*/, header: `${fecha.getDate()} ${months[(fecha.getMonth() % 12) + 1]}` };
    columns.push(obj);
 
    fecha.setDate(fecha.getDate() + 1);
  }

    useEffect(() => {

        

        setLawyers( [{ id : idlawyer}]) ; // Registraos 
        
    }, []);

    useEffect((lawyers) => {
        getHorarios() ; // Cargamos los horaros del abogado actual
    } , [lawyers])

    return (
        <div className="card" style={{  maxWidth: '100%' , minHeight : '200px', maxHeight : '300px'}} >
            <DataTable value={horariosFull[0]?.horarios} scrollable scrollHeight="300px"
              tableStyle={{ minWidth: '50rem' }}>
                {/* <Column field="code" header="Code"></Column>
                <Column field="name" header="Name"></Column>
                <Column field="category" header="Category"></Column>
                <Column field="quantity" header="Quantity"></Column> */}


                {columns.map( (col , index ) => {
                  return <Column key={index} field={index.toString()} header={col.header} style={{height:'20px'}} />
                })}


            </DataTable>

            <ConfirmaCitaLawyer theState={theState} getAction={getAction}
             confirmCalendar={confirmCalendar}></ConfirmaCitaLawyer>
        </div>
    );
}
        


/*

  Hola Mariano , estoy trabajando en los cambios que me indicaste . Solo pera entar en sincronia serian :

  1.- En "Encuentra un abogado" se esta dirigiendo a dar de alta abogado , Se deberia de ir a "Agenda Tu Cita desde hoy "
      "Al no estar registrado el cliente lo debemos de invitar a que se de de alta anter de proceder a la cita"

  2.- En "Consulta express" , si el cliente no esta registrado o logueado , lo invitamos a hacerlo para proceder
      a la pantalla de consulta express

  3.- Quitar los letreros de legaltek por iustia

  Si es necesario que hablemos para comentar me lo dices y nos conectamos


*/